import Menu from './menu';
import MenuItem from './menu-item';
import Submenu from './submenu';

Menu.Item = MenuItem;
Menu.Sub = Submenu;

export default Menu;
